<template>

    <Head :title="nx_page.name">
        <meta
            type="title"
            :content="nx_page.seo_meta_title"
            head-key="title"
        >
        <meta
            type="description"
            :content="nx_page.seo_meta_description"
            head-key="description"
        >
        <meta
            type="keywords"
            :content="nx_page.seo_meta_keywords"
            head-key="keywords"
        >
    </Head>

    <h1>ABOUT</h1>
    <div v-html="nx_page.description"></div>

</template>

<script>
export default {
    name: "About",

    props: {
        nx_page: Object,
    }
}
</script>

<style scoped>

</style>
